// Players address each other by game name only; the roster number is just a head count.
// During the game the remaining players are numbered 1..N in seat order, so the last number
// always equals how many are still at the table.
// The final keeps the real seats because every player is shown again.
export const withTableNumbers = (match) => {
    if (match.stage === 'final')
        return match;
    const players = [...match.players].sort((a, b) => a.number - b.number).map((p, i) => (Object.assign(Object.assign({}, p), { number: i + 1 })));
    return Object.assign(Object.assign({}, match), { players });
};
